class OaklenHeroSlider extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.slides = Array.from(this.querySelectorAll('[data-oaklen-hero-slide]'));
    this.contents = Array.from(
      this.querySelectorAll('[data-oaklen-hero-content]'),
    );
    this.tabs = Array.from(this.querySelectorAll('[data-oaklen-hero-tab]'));
    this.activeIndex = 0;
    this.intervalId = null;
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplayInterval = Number.parseInt(
      this.dataset.autoplayInterval || '6000',
      10,
    );
    this.reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;
    this.handleMouseEnter = this.pause.bind(this);
    this.handleMouseLeave = this.play.bind(this);
    this.handleFocusIn = this.pause.bind(this);
    this.handleFocusOut = this.play.bind(this);

    this.style.setProperty(
      '--oaklen-hero-slider-tabs',
      this.tabs.length || this.slides.length || 1,
    );

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = Number.parseInt(tab.dataset.index || '0', 10);
        this.setActive(index, true);
      });
    });

    this.addEventListener('mouseenter', this.handleMouseEnter);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    this.addEventListener('focusin', this.handleFocusIn);
    this.addEventListener('focusout', this.handleFocusOut);

    this.setActive(0, false);
    this.play();
  }

  disconnectedCallback() {
    this.stop();
    this.removeEventListener('mouseenter', this.handleMouseEnter);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
    this.removeEventListener('focusin', this.handleFocusIn);
    this.removeEventListener('focusout', this.handleFocusOut);
  }

  setActive(index, restart) {
    if (!this.slides.length) return;

    const nextIndex = (index + this.slides.length) % this.slides.length;
    this.activeIndex = nextIndex;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === nextIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.contents.forEach((content, contentIndex) => {
      const isActive = contentIndex === nextIndex;
      content.classList.toggle('is-active', isActive);
      content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === nextIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (restart) {
      this.play(true);
    }
  }

  next() {
    this.setActive(this.activeIndex + 1, false);
  }

  play(restart = false) {
    if (!this.autoplayEnabled || this.reducedMotion || this.slides.length < 2)
      return;

    this.classList.remove('is-paused');

    if (restart) {
      this.stop();
    }

    if (this.intervalId) return;

    this.intervalId = window.setInterval(
      () => this.next(),
      this.autoplayInterval,
    );
  }

  pause() {
    this.classList.add('is-paused');
    this.stop();
  }

  stop() {
    if (!this.intervalId) return;

    window.clearInterval(this.intervalId);
    this.intervalId = null;
  }
}

if (!customElements.get('oaklen-hero-slider')) {
  customElements.define('oaklen-hero-slider', OaklenHeroSlider);
}
